import React from 'react'
import styled from 'styled-components'
import Iframe from 'react-iframe'
import Container from '../container'
import White from '../white'

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  border-radius: 20px;
`

const RouteContainer = styled.div`
  h2 {
    margin-left: 0;
  }
`

const Image = styled.img`
  aspect-ratio: 4/5;
  object-fit: cover;
  border-radius: 20px;
`

const IntroHeading = styled.h5`
  text-transform: uppercase;
  font-size: 22px;
  line-height: 32px;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 100px;
`

const Route = styled.div`
  iframe {
    border: none;
  }
  p {
    margin-bottom: 100px;
  }
`

const PleaseNote = styled.div`
  margin-top: 80px;
  margin-bottom: 80px;
`

const Routes = ({module}) => {

  return (
    <White borderbottom>
    <Container>
    <RouteContainer>
    <h2>{module.heading}</h2>
    <Flex>

      <Route>
      <IntroHeading>FULL ROUTE</IntroHeading>
      <p>{module.full_route_line_1}<br />{module.full_route_line_2}</p>
      <Iframe url={module.full_route_embed}
        width="640px"
        height="700px"
        id=""
        className=""
        display="block"
        position="relative"/>
      <PleaseNote>{module.fineprint}</PleaseNote>
      </Route>

      <Route>
      <IntroHeading>SHORT ROUTE</IntroHeading>
      <p>{module.short_route_line_1}<br />{module.short_route_line_2}</p>
      <Iframe url={module.short_route_embed}
        width="640px"
        height="700px"
        id=""
        className=""
        display="block"
        position="relative"/>

      </Route>

    </Flex>
    </RouteContainer>
    </Container>
    </White>
  )
}

export default Routes
